// You can write more code here

/* START OF COMPILED CODE */

import LaneEntityImage from "./LaneEntityImage";
/* START-USER-IMPORTS */
import { BodyTypes } from '../LevelManager';
import { Passenger } from '../Passenger';
import { Vehicle } from '../../Vehicle';
import GameUI from '../../scenes/GameUI';
/* END-USER-IMPORTS */

export default class TaxiDropOff extends LaneEntityImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 125.5, y ?? 185.5, texture || "game", frame ?? "taxi_rank.png");

    /* START-USER-CTR-CODE */
    this.hasPassenger = false;
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */
  protected hasPassenger: boolean;
  protected passenger: Passenger | undefined;

  public init() {
    (this.body as MatterJS.BodyType).label = BodyTypes.TaxiDropOff;
    (this.body as MatterJS.BodyType).onCollideCallback = this.onCollisionStart.bind(this);
  }

  public setPassenger(passenger: Passenger) {
    this.passenger = passenger;
    this.hasPassenger = false;
  }

  protected onCollisionStart(pair: MatterJS.ICollisionPair) {
    if (this.hasPassenger) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.Vehicle && (pair.bodyB as MatterJS.BodyType).label == BodyTypes.TaxiDropOff) {
      this.onVehicleCollisionStart(pair, pair.bodyA as MatterJS.BodyType, pair.bodyB as MatterJS.BodyType);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.Vehicle && (pair.bodyA as MatterJS.BodyType).label == BodyTypes.TaxiDropOff) {
      this.onVehicleCollisionStart(pair, pair.bodyB as MatterJS.BodyType, pair.bodyA as MatterJS.BodyType);
    }
  }

  protected onVehicleCollisionStart(pair: MatterJS.ICollisionPair, vehicle: MatterJS.BodyType, taxiRank: MatterJS.BodyType) {
    if (vehicle.gameObject instanceof Vehicle && vehicle.gameObject.IsTaxi && !this.hasPassenger && this.passenger) {

      let dropoffData = vehicle.gameObject.dropOffPassenger(this.passenger);
      if (dropoffData.success) {
        this.passenger.droppedOff();
        this.scene.events.emit(GameUI.events.Dropoff,this.passenger.Icon,vehicle.gameObject,dropoffData.bonusAmount);
        this.passenger = undefined;
        this.hasPassenger = true;
        
      
      }
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
